export const scrolledElementType = {
  WRAPPER: 'wrapper',
  IFRAME: 'iframe',
};
